import type { TenantMembershipDto } from "../types";

/** Quantos CTs o usuário é dono (`owner`), base para o limite de CTs por usuário. */
export function ownedTenantCount(tenants: TenantMembershipDto[]): number {
  return tenants.filter(t => t.roleSlug === "owner").length;
}

/** `true` quando o usuário já atingiu o limite de CTs que pode criar/possuir. */
export function hasReachedTenantLimit(tenants: TenantMembershipDto[], ctLimit: number): boolean {
  return ownedTenantCount(tenants) >= ctLimit;
}